import { cn } from "../../../lib/utils.js";
import { splitLinkifiedText } from "./linkified-text.js";

const LINK_CLASS =
  "rounded-sm text-accent underline decoration-accent/40 underline-offset-2 [overflow-wrap:anywhere] [unicode-bidi:isolate] break-all hover:decoration-accent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-focus";

export function LinkifiedText({
  text,
  className,
}: {
  text: string;
  className?: string;
}): React.JSX.Element {
  const parts = splitLinkifiedText(text);

  return (
    <>
      {parts.map((part, index) =>
        part.type === "link" ? (
          <a
            key={`link-${index}`}
            href={part.href}
            target="_blank"
            rel="noopener noreferrer"
            dir="ltr"
            className={cn(LINK_CLASS, className)}
          >
            {part.value}
          </a>
        ) : (
          part.value
        ),
      )}
    </>
  );
}
